module.exports = __webpack_public_path__ + "img/404.f5a66035.png";